module.exports = __webpack_public_path__ + "static/media/icon_transportation.0e959fda.svg";